<template>
    <!-- 融资提单列表 -->
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束时间"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.order_sn" placeholder="合同号"></el-input>
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('pledgeissuing')">
                    <el-option v-for="(list,index) in selectMap.pledgeissuing" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.status" placeholder="融资状态" @visible-change="getSelectList('pledgestatus')">
                    <el-option v-for="(list,index) in selectMap.pledgestatus" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
               <!-- <el-select class="search_select search_inputBox" v-model="params.finance_type" multiple collapse-tags placeholder="融资类型" @visible-change="getSelectList">
                    <el-option :value="1" label="L/C"></el-option>
                    <el-option :value="2" label="T/T"></el-option>
                    <el-option :value="3" label="D/P"></el-option>
                </el-select> -->
                <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="finance.pledge.reports" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow"  @relativefile="relativeFile" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计</div>
                <div class="totalNumber">融资提单:{{totalObj.finance_order_count}}单</div>
                <div class="totalNumber">融资件数:{{totalObj.finance_number}}件</div>
                <div class="totalNumber">融资方数:{{totalObj.finance_cube}}m³</div>
                <div class="totalNumber">融资金额:{{totalObj.finance_amount}}</div>
                <div class="totalNumber">融资费用:{{totalObj.finance_cost}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="finance.pledge.reports" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
            <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>

        </div>
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    import relativeFile from '../../../components/downloadRelativeFile.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                startintime:"",
                params:{
                    start_time:"",
                    end_time:"",
                    order_sn:"",
                    issuing_id:"",
                    status:"",
                    finance_type:"",
                    page:1,
                    per_page:50
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
                last_page:1,
                total:0,
                selectRow:[],
                warehouseList:[],
                warehouse_id:"",
                pieces:"",
                cube:"",
                return_pieces:"",
                return_cube:"",
                check_cube:"",
                sales_cube:"",
                inbound_time:new Date(),
                breedList:[],
                brandList:[],
                supplierList:[],
                selectMap:{
                    pledgeissuing:[],
                    pledgestatus:[]
                },
                list:[],
                tableCol:[
                    {colName:"融资时间",colKey:"finance_date",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"融资提单号",colKey:"order_sn",colWidth:135,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"融资状态",colKey:"finance_status_text",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货物品名",colKey:"breed",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"件数",colKey:"finance_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"方数",colKey:"finance_cube",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货物本金",colKey:"finance_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"税金",colKey:"agent_tax",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"代理费用",colKey:"agent_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"银行费用",colKey:"bank_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"保险",colKey:"insure_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"赎货平均单价",colKey:"cube_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"赎货金额",colKey:"redeem_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"当前利息",colKey:"interest",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"当前仓储费",colKey:"storage_fee",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"当前其他费用",colKey:"other_cost",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联采购合同号",colKey:"contract_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联文件",colKey:"files",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isRelativeFile:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联发票号",colKey:"invoice_no",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                isShowMore:false,
                downLoadFileDialog:false,
                downFilesList:[],
            }
        },
        created(){
            if(sessionStorage.FINANCECON_ID){
                this.id=sessionStorage.FINANCECON_ID;
                this.params.purchase_id=sessionStorage.FINANCECON_ID;
                sessionStorage.removeItem("FINANCECON_ID")
            }
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.startintime = "";
                this.params=this.resetSearch(this.params)
                this.getList();
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                this.downFilesList = obj.files;
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                // this.params.startintime=this.formatTimeZero(this.startintime);
                this.tableLoading = true;
                this.params.purchase_id = this.id;
                this.$postColumnList("/erp/finance.pledge.reports",this.params,res=>{
                    this.pl(res.data.data.data.last_page)
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj = res.data.data.total;
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        item.purchase_id="查看对账单";
                        if(item.finance_date!=0){
                            this.list[index].finance_date = this.formatTime(item.finance_date*1000)
                        }else{
                            this.list[index].finance_date = "";
                        }
                        // if(item.expected_kiln_time!=0){
                        //     this.list[index].expected_kiln_time = this.formatTime(item.expected_kiln_time*1000)
                        // }else{
                        //     this.list[index].expected_kiln_time = "";
                        // }
                        // this.list[index].original_width_total = parseInt(this.list[index].original_width_total)
                        this.list[index].cube = this.keepLimit(this.list[index].cube)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            rowClick(obj){
                if(obj.name =='order_sn'){
                    sessionStorage.removeItem("FINANCE_DETAIL_ID")
                    sessionStorage.setItem("FINANCE_DETAIL_ID",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '融资明细'+obj.id,
                        label: '融资明细',
                        content: 'bankFinanceDetail'
                    });
                }
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
            excelExport(){
                this.params.purchase_id = this.id;
                this.$exportExecl("/erp/finance.pledge.reports .export","融资提单列表",this.params)
            },
        },
        components:{
            tabletem,
            pagination,
            relativeFile
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
</style>
